var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "emap-flow-modal-changeAssignee" },
    [
      (_vm.options.groups && _vm.users.length) || _vm.isMultiInstance
        ? _c(
            "Modal",
            {
              attrs: {
                title: _vm.$LocalH5("selectMember"),
                "mask-closable": false,
              },
              model: {
                value: _vm.groupVisible,
                callback: function ($$v) {
                  _vm.groupVisible = $$v
                },
                expression: "groupVisible",
              },
            },
            [
              _c("div", { staticClass: "container" }, [
                _vm.isMultiInstance
                  ? _c("div", { staticClass: "ivu-form-item" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$LocalH5("toolbar.toUserGroup"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ivu-form-item-content",
                          staticStyle: { "margin-left": "100px" },
                        },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.group,
                                callback: function ($$v) {
                                  _vm.group = $$v
                                },
                                expression: "group",
                              },
                            },
                            _vm._l(_vm.groups, function (item, index) {
                              return _c(
                                "Option",
                                { key: index, attrs: { value: item.id } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : _c("div", { staticClass: "ivu-form-item" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$LocalH5("toolbar.toPersonnel"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ivu-form-item-content",
                          staticStyle: { "margin-left": "100px" },
                        },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.user,
                                callback: function ($$v) {
                                  _vm.user = $$v
                                },
                                expression: "user",
                              },
                            },
                            _vm._l(_vm.users, function (item, index) {
                              return _c(
                                "Option",
                                { key: index, attrs: { value: item.userId } },
                                [_vm._v(_vm._s(item.userName))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "Button",
                    {
                      attrs: { size: "large" },
                      on: {
                        click: function ($event) {
                          _vm.groupVisible = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$LocalH5("buttonCancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "Button",
                    {
                      attrs: {
                        type: "primary",
                        size: "large",
                        disabled: !(_vm.user || _vm.group),
                      },
                      on: { click: _vm.onGroupConfirm },
                    },
                    [_vm._v(_vm._s(_vm.$LocalH5("buttonConfirm")))]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.options.groups || _vm.emptyUsers
        ? _c("emap-flow-pick", {
            on: { "on-confirm": _vm.onConfirm },
            model: {
              value: _vm.visible,
              callback: function ($$v) {
                _vm.visible = $$v
              },
              expression: "visible",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }